import { render, staticRenderFns } from "./verifyRecord.vue?vue&type=template&id=cb43f794&scoped=true"
import script from "./verifyRecord.vue?vue&type=script&lang=js"
export * from "./verifyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb43f794",
  null
  
)

export default component.exports